import React, { forwardRef, useRef, useState, useEffect, createRef } from 'react'
import ReactDOM, { render } from 'react-dom'
//@ts-ignore
// import { useStore } from '../../index'
// import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
//@ts-ignore
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Form.scss'
import { FormTitle } from 'components/form/formTitle';
import { IForm, IFormPage, IField, IOption } from 'shared/model/form';
import { FormGroup } from 'react-reactive-form';
import { FormSection } from 'components/form/formSection';
import { Header } from 'components/header';
import { Select } from 'components/select';
import { navigate } from '@reach/router';
import { CouponInformation } from "components/couponInformation"
//@ts-ignore
import SimpleLineIcon from 'react-simple-line-icons';
//@ts-ignore
import moment from 'moment';
import { CardLayout } from "components/cardLayout";
import { Button } from "components/button";
import { client } from "App";
import { saveSignatures } from '../../core/services/saveSignatures'
//@ts-ignore
import SignatureCanvas from 'react-signature-canvas'
//import {MovePaperWorkEstimate} from 'components/movePaperWorkEstimate'
import { runInThisContext } from 'vm';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { makeRequest } from '../../core/services/payDepositService'
const couponDates = JSON.parse(localStorage.getItem("CouponDates") || '{}');

/*const couponDates =[
    "28-11-2019",
    "29-11-2019",
    "10-12-2019",
    "11-12-2019",
    "12-12-2019",
    "13-12-2019",
    "21-12-2019",
    "22-12-2019",
    "23-12-2019"
] */

export interface FormProps {
    form: IForm;
    formGroup: FormGroup;
    index: number;
    disableSwipe?: boolean;
    hideNextButton?: boolean;
    hideProgressTabs?: boolean;
    backNavigation?: boolean;
    headerHeight?: string;
    width: number;
    ref?: any;
    submitted?: boolean;
    onSave?(): void;
    onDiscard?(): void;
    onValueChange?(value: any): void;
    onIndexChange?(index: number): void;
    onBack?(): void;
    onPreviousPage?(): void;
    onFooterTap?(): void;
    onLogoTap?(): void;
    onMount?(sliderRef: any): void;
    onClick?(): any;

}

export interface FormState {
    progress: any;
    currentIndex: number;
    formPages: IFormPage[];
    footer: boolean;
    coupon: boolean;
    initialSlide: number;
    swiperSetting: any;
    alignTo: boolean;
    text?: any;
}

declare global {
    interface Window { dataLayer: any; }
}
window.dataLayer = window.dataLayer || {};


class Form extends React.Component<FormProps, FormState> {
    sliderRef: any;

    //private myPaperWorkEstimateComp = createRef<MovePaperWorkEstimate>()

    constructor(props: FormProps) {
        super(props);
        let index = 0;
        console.log(window.location.search);
        var index1 = this.props.form.formPages.findIndex((item: any) => item.key === 'amslanding');
        //debugger;
        // if (window.location.search === '?question=deposit') {
        //   //  this.props.form.formPages = this.getFullPages(this.props.form);
        //     index = this.props.form.formPages.findIndex((item: any) => item.key === 'deposit');
        // } else
        if (window.location.search === '?question=paperwork') {
            //debugger;
            // this.props.form.formPages = this.getFullPages(this.props.form);
            //this.props.form.formPages = this.getFullPages(this.props.form);
            index = this.props.form.formPages.findIndex((item: any) => item.key === 'paperwork');
        } else if (window.location.search === '?question=booked') {

            // this.props.form.formPages = this.getFullPages(this.props.form);
            //this.props.form.formPages = this.getFullPages(this.props.form);
            index = this.props.form.formPages.findIndex((item: any) => item.key === 'booked');
        }


        else if (window.location.search === '?question=amslanding') {
            index = this.props.form.formPages.findIndex((item: any) => item.key === 'amslanding');
        }
        this.props.form.currentFormPageIndex = index;
        navigate(`${'move'}?question=${this.props.form.currentFormPage.key}`);

        // this.props.form.currentFormPageIndex = index;
        // if(this.props.form.currentFormPage===undefined){
        //     navigate('/');
        // }else{
        //     navigate(`${'move'}?question=${this.props.form.currentFormPage.key}`);
        // }

        this.state = {
            progress: (((this.props.form.currentFormPageIndex + 1) / this.props.form.formPages.length) * 100),
            currentIndex: this.props.index,
            formPages: this.props.form.visibleFormPages,
            footer: (window.location.search === '?question=paperwork') ? true : false,
            //footer:this.showHideFooter(),
            coupon: false,
            initialSlide: index,
            swiperSetting: this.swiperSetting(index),
            alignTo: true,
            text: "continueeeeeee"

        };
        console.log("const footer:" + this.state.footer);

        this.onFormChanges = this.onFormChanges.bind(this);
        this.beforeChange = this.beforeChange.bind(this);
    }


    // const Form = ({ form, formGroup, index, width, onValueChange, onIndexChange, onBack, submitted }: FormProps, sliderRef: any) => {
    // const sliderRef = useRef(null) // Our main dom Ref
    // const navigate = useStore((state: any) => state.navigate)
    // const endNav = useStore((state: any) => state.endNav)

    // const [formPages, setFormPages] = useState(form.visibleFormPages);
    // const [currentFormPage, setCurrentFormPage] = useState(form.currentFormPage);
    // const [currentIndex, setCurrentIndex] = useState(index);
    // const [progress, setProgress] = useState((((form.currentFormPageIndex + 1) / form.formPages.length) * 100));

    componentDidMount() {
        this.props.formGroup.valueChanges.subscribe(this.onFormChanges);
        console.dir(window.location);
        // if (window.location.search === '?question=type') {
        //     debugger;
        //     let index = 1;
        //     this.props.form.currentFormPageIndex = index;
        //     this.setState({ initialSlide: index, swiperSetting: this.swiperSetting(index) });
        //     navigate(`${'move'}?question=${this.props.form.currentFormPage.key}`);
        // } else {
        //     navigate(`${'move'}?question=${this.props.form.currentFormPage.key}`);
        // }
        var key = "/" + this.props.form.currentFormPage.key
        console.log(this.props.form.currentFormPage.key);
        window.dataLayer.push({
            event: 'pageview',
            page: { path: key }
        })
        if (this.props.onMount) {
            // debugger;
            this.props.onMount(this.sliderRef);
        }

    }

    componentDidUpdate(prevProps: FormProps) {
        if (this.props.formGroup !== prevProps.formGroup) {
            // debugger;
            this.props.formGroup.valueChanges.subscribe(this.onFormChanges);
        }
    }

    componentWillUnmount() {
        console.log("componentWillUnmount form")
        // debugger;
        this.props.formGroup.valueChanges.unsubscribe(this.onFormChanges);
        window.onpopstate = null;
        // if (this.props.onBack) {
        //     this.props.onBack();
        // }
    }

    goToNextPage() {
        if (this.sliderRef && !this.props.form.isLastPage) {
            setTimeout(() => {
                this.sliderRef.slickNext();
            }, 10)
        }
    }

    onFooterTap() {
        localStorage.setItem("notsure", "1")
        this.goToNextPage();
        if (this.props.onFooterTap) {
            this.props.onFooterTap();
        }
    }

    goToPreviousPage() {
        if (this.sliderRef) {
            this.sliderRef.slickPrev();
        }
        if (this.props.onPreviousPage) {
            this.props.onPreviousPage();
        }
    }

    onFormChanges(value: any) {
        var key = this.props.form.currentFormPage.key;

        // alert("key:"+key);
        // if(key.toLowerCase()=="todo" ){
        //    // alert("todo");
        //     var todo=this.props.formGroup.value.toDo;
        //     //debugger;
        //     if(todo=="1"){
        //         this.props.formGroup.value.sign="9999";
        //         this.hideFooter();
        //         console.log("todo hide footer:"+this.state.footer);
        //     }else if(todo==="0" || todo==false){
        //         this.props.formGroup.value.sign="999";
        //         this.showFooter();
        //         console.log("todo show footer:"+this.state.footer);
        //     }
        // }
        if (key.toLowerCase() == "paperwork") {
            // alert("paper");
            var sign = this.props.formGroup.value.sign;
            // var todo=this.props.formGroup.value.toDo;
            // var isAffirm=(localStorage.getItem("isAffirm") || "0");

            var signs = JSON.parse(localStorage.getItem("signs") || "[]");
            var signFirst = signs[0];
            var signSecond = signs[1];

            // if(sign=="1"){
            //     this.hideFooter();
            //     console.log("paperwork hide footer:"+this.state.footer);
            // }else if(sign==="0"){
            //     this.showFooter();
            //     console.log("paperwork show footer:"+this.state.footer);
            // }else 
            console.log("onFormChanges footer:" + this.state.footer);//signFirst.sign==""
            if (sign == "2") {
                this.setState({ text: "Continue" });
            } else if (sign == "3") {
                this.setState({ text: "Book Now" });
                //this.setState({text:"Continue"});
            }

            // if(isAffirm=="1"){
            //     this.hideFooter();
            //     console.log("todo hide footer:"+this.state.footer);
            // }else if(isAffirm==="0"){
            //     this.showFooter();
            //     console.log("todo show footer:"+this.state.footer);
            // }

        }
        // setTimeout(() => {
        //     clearAllBodyScrollLocks()
        // }, 400);
        this.setState({ formPages: [...this.props.form.getVisiblFormPages(this.props.form.formPages)] })


        // Automatically move to next page on single bubble selection.
        if (this.props.form.currentFormPage.valid && this.props.form.currentFormPage.goNextOnValid) {
            if (!this.props.form.isLastPage) {
                this.goToNextPage();
            }
            let field: IField | IField[] = this.props.form.currentFormPage.fields[0] as IField;
            //  console.clear();
            var key = "/" + this.props.form.currentFormPage.key;
            console.dir(key)
            console.log(value);

            console.log(this.props.form.currentFormPage)

            if (typeof field === 'object' && field.fieldType === 'singleSelect') {
                // setTimeout(() => {
                // }, 100)
            }
        }

        if (this.props.onValueChange) {
            this.props.onValueChange(value);
        }
    }

    onFormPageButtonClick() {
        if (this.props.form.currentFormPage.valid && !this.props.form.currentFormPage.goNextOnValid) {
            if (!this.props.form.isLastPage) {
                this.goToNextPage();
            }
        }
    }

    beforeChange(oldIndex: number, newIndex: number) {

        let progress: number = ((newIndex + 1) / this.props.form.formPages.length) * 100;
        this.setState({ progress: progress });

        // Scroll view to top on web
        window.scrollTo(0, 0);

        let nextFormPage = this.props.form.formPages[newIndex];
        if (nextFormPage) {
            navigate(`${'move'}?question=${nextFormPage.key}`);
            window.onpopstate = (e: any) => {
                console.log("Browser back button presses");
                if (this.props.form.currentFormPageIndex !== 0) {
                    this.goToPreviousPage();
                } else {
                    if (this.props.onBack) {
                        this.props.onBack();
                    }
                }
            }
            this.setState({ footer: !!nextFormPage.footer })
            console.log("beforeChange footer:" + this.state.footer);
        }

        this.props.form.currentFormPageIndex = newIndex;
        var key = "/" + this.props.form.currentFormPage.key;
        window.dataLayer.push({
            event: 'pageview',
            page: { path: key }
        })
        if (this.props.form.currentFormPage.key === "paperwork") {
            var sign = this.props.formGroup.value.sign;

            if (sign === "2") {
                this.setState({ text: "Continue" })
            } else if (sign === "3") {
                this.setState({ text: "Book Now" })
            } else if (sign === "99" || sign === "0") {
                this.setState({ text: this.state.text })
            } else {
                this.setState({ text: "Sign Estimate" })
            }
        }
        if (this.props.form.currentFormPage.key === "movingknowledge") {
            this.setState({ text: "My Pricing", footer: true })
        }

        this.setState({ currentIndex: newIndex });
    }

    swiperSetting(initialSlideIndex: number): any {
        return {
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            lazyLoad: 'ondemand',
            initialSlide: initialSlideIndex,
            adaptiveHeight: true,
            // fade: true,
            // useCNumberLiteralSS: true,
            // useTransform: true,
            // cssEase: `cubic-bezier(0.39, 0.575, 0.565, 1)`,
            speed: 500,
            // draggable: true,
            // variableWidth: true,
            swipe: false,
            beforeChange: (oldIndex: number, newIndex: number) => this.beforeChange(oldIndex, newIndex),
            afterChange: (index: any) => {
                this.props.form.currentFormPageIndex = index;
                let progress: number = ((index + 1) / this.props.form.formPages.length) * 100;
                this.setState({ progress: progress });
                this.setState({ currentIndex: index });


                if (this.props.onIndexChange) {
                    this.props.onIndexChange(index);
                }



            }
        };
    }


    onBackPress() {
        if (this.props.form.currentFormPageIndex === 0) {
            if (this.props.onBack) {
                this.props.onBack();
            }
        } else {
            this.goToPreviousPage();
        }

        console.log("onBackPress form")
    }

    onLogoPress() {
        if (this.props.onLogoTap) {
            this.props.onLogoTap();
        }
    }

    getFullPages(form: IForm): IFormPage[] {
        let formPages: IFormPage[] = [form.formPages[0]];
        let localOption: IOption | undefined = ((form.formPages[0].fields[0] as IField).options || []).find(item => item.label === "Local");
        if (localOption) {
            //@ts-ignore
            formPages.push(...localOption.subFormPages)
            //@ts-ignore
            let apartmentOption: IOption | undefined = (localOption.subFormPages[0].fields[0] as IField).options.find(item => item.value === "Apartment");
            if (apartmentOption) {
                //@ts-ignore
                formPages.push(...apartmentOption.subFormPages)
                //@ts-ignore
                let onebedroomOption: IOption | undefined = (apartmentOption.subFormPages[0].fields[0] as IField).options.find(item => item.value === "1 Bedroom Apartment");
                if (onebedroomOption) {
                    //@ts-ignore
                    formPages.push(...onebedroomOption.subFormPages)
                }
            }
        }
        return formPages;
    }

    goToBottom11() {
        var sign = this.props.formGroup.value.sign;
        var key = this.props.form.currentFormPage.key;

        var signs = JSON.parse(localStorage.getItem("signs") || "[]");
        var signFirst = signs[0];
        var signSecond = signs[1];

        if (key.toLowerCase() == "paperwork") {

            var isAffirm = (localStorage.getItem("isAffirm") || "0");
            const { text } = this.state //destucture state

            if (text === "Sign Estimate" && sign == false) {
                this.props.formGroup.value.sign = "99";
                const element: any = document.getElementById("firstsignpad");
                if (element) {
                    element.scrollIntoView({ block: 'end', behavior: 'smooth' });
                }
            } else if (text === "Sign Estimate" && sign == "99") {
                this.props.formGroup.value.sign = "99";
                const element: any = document.getElementById("firstsignpad");
                if (element) {
                    element.scrollIntoView({ block: 'end', behavior: 'smooth' });
                }
                alert("Please sign here.");
            }
            else if (text === "Continue" && sign == "2") {
                this.setState({ text: "Sign Order Of Service" });
            } else if (text === "Sign Order Of Service" && (sign == "2")) {
                this.props.formGroup.value.sign = "99";
                let element: any = document.getElementById("secondsignpad");
                if (element) {
                    element.scrollIntoView({ block: 'end', behavior: 'smooth' });
                }
            } else if (text === "Sign Order Of Service" && sign == "99") {
                this.props.formGroup.value.sign = "99";
                let element: any = document.getElementById("secondsignpad");
                if (element) {
                    element.scrollIntoView({ block: 'end', behavior: 'smooth' });
                }
                alert("Please sign here.");
            } else {
                // else if (text === "Continue" && sign=="0") {
                //     this.validateSigns();
                // }
                // else if (text === "Continue" && (sign=="3" || sign=="2")) {
                //else if (text === "Book Now" || sign==="0") {
                if (this.validateSigns() == true) {
                    //this.goToNextPage();
                    if (isAffirm == "0") {
                        this.saveSignatures("0");
                    } else {
                        this.saveSignatures("1");
                        // navigate("/amsLanding");
                    }
                } else {
                    alert("Please sign here.");
                }
            }
            //else if (text === "Sign Order Of Service" && sign=="3") {
            //this.setState({ text: "Book Now" }); 
            //}
            // else if (text === "Book Now") {
            //     // alert("api");
            //     if(this.validateSigns()==true){
            //         //this.goToNextPage();
            //         if(isAffirm=="0"){
            //             this.saveSignatures();
            //         }else{
            //             this.hideFooter();
            //             console.log("Book Now hide footer:"+this.state.footer);
            //         }
            //     }else{
            //         alert("Please sign here.");
            //     }
            // }
        }

        else if (key.toLowerCase() == "movingknowledge") {
            this.goToNextPage();
        }
    }

    goToBottom() {
        var sign = this.props.formGroup.value.sign;
        var key = this.props.form.currentFormPage.key;

        var signs = JSON.parse(localStorage.getItem("signs") || "[]");
        var signFirst = signs[0];
        var signSecond = signs[1];

        if (key.toLowerCase() == "paperwork") {

            var isAffirm = (localStorage.getItem("isAffirm") || "0");
            const { text } = this.state //destucture state

            if (text === "Sign Estimate" && signFirst.sign == "") {
                this.props.formGroup.value.sign = "99";
                const element: any = document.getElementById("firstsignpad");
                if (element) {
                    element.scrollIntoView({ block: 'end', behavior: 'smooth' });
                }
            } else if (text === "Sign Estimate" && sign == "99") {
                this.props.formGroup.value.sign = "99";
                const element: any = document.getElementById("firstsignpad");
                if (element) {
                    element.scrollIntoView({ block: 'end', behavior: 'smooth' });
                }
                alert("Please sign here.");
            }
            else if (text === "Continue" && (sign == "2" && signSecond.sign != "")) {
                this.processSignatures();
            }
            else if (text === "Continue" && sign == "2") {
                this.setState({ text: "Sign Order Of Service" });
            } else if (text === "Sign Order Of Service" && (sign == "2")) {
                this.props.formGroup.value.sign = "99";
                let element: any = document.getElementById("secondsignpad");
                if (element) {
                    element.scrollIntoView({ block: 'end', behavior: 'smooth' });
                }
            } else if (text === "Sign Order Of Service" && sign == "99") {
                this.props.formGroup.value.sign = "99";
                let element: any = document.getElementById("secondsignpad");
                if (element) {
                    element.scrollIntoView({ block: 'end', behavior: 'smooth' });
                }
                alert("Please sign here.");
            } else {
                this.processSignatures();
            }
        }

        else if (key.toLowerCase() == "movingknowledge") {
            this.goToNextPage();
        }
    }
    validateSigns() {
        var signs = JSON.parse(localStorage.getItem("signs") || "[]");
        var signFirst = signs[0];
        var signSecond = signs[1];
        var sign = this.props.formGroup.value.sign;

        if (signFirst.id == "1" && signFirst.sign == "") {
            const element: any = document.getElementById("firstsignpad");
            if (element) {
                element.scrollIntoView({ block: 'end', behavior: 'smooth' });
            }
            return false;
        }
        else if (signSecond.id == "2" && signSecond.sign == "") {
            const element: any = document.getElementById("secondsignpad");
            if (element) {
                element.scrollIntoView({ block: 'end', behavior: 'smooth' });
            }
            return false;
        }
        return true;
    }

    processSignatures() {
        var isAffirm = (localStorage.getItem("isAffirm") || "0");
        if (this.validateSigns() == true) {
            //alert("isAffirm"+isAffirm);
            if (isAffirm == "0") {
                this.saveSignatures("0");
            } else {
                this.saveSignatures("1");
            }

            // var cusDetails:any = localStorage.getItem("customerDetails")
            // console.log("Local Customer Data",JSON.parse(cusDetails));
            this.sendQuoteEmail();

        } else {
            alert("Please sign here.");
        }
    }
    async saveSignaturesAPI(params: any) {
        return client.query({
            query: saveSignatures, variables: {
                sigInput: {
                    "customerID": params.customerID,
                    "moveID": params.moveID,
                    "moveDailySheetID": params.moveDailySheetID,
                    "estimatorID": params.estimatorID,
                    "signature1": params.signature1,
                    "signature2": params.signature2
                }
            }
        });
    }


    saveSignatures(flag: string) {
        var Customer = JSON.parse(localStorage.getItem("customerDetails") || '{}')

        var signs = JSON.parse(localStorage.getItem("signs") || "[]");
        var signFirst = signs[0];
        var signSecond = signs[1];

        var params = {
            customerID: Customer.customerID,
            moveID: Customer.moveID,
            moveDailySheetID: Customer.moveDailySheetID,
            estimatorID: Customer.estimatorID,
            signature1: signFirst.sign,
            signature2: signSecond.sign
        }
        this.saveSignaturesAPI(params)
            .then(response => {
                console.log(JSON.stringify(response));
                if (response.data.saveSignatures[0].responseCode.length > 0) {
                    console.log("Signatures are saved.");

                    //navigate("/move?question=deposit");
                    if (flag == "0") {
                        this.goToNextPage();
                    } else {
                        navigate("/amsLanding");
                        //navigate("/move?question=amslanding");
                        //this.goToNextPage();
                    }
                } else {
                    console.log("Signatures are not saved.");
                }
            });
    }



    sendQuoteEmail() {

        var Customer = JSON.parse(localStorage.getItem("customerDetails") || '{}')
        var Estimator = JSON.parse(localStorage.getItem("EstimatorUserDetails") || '{}')
        var estimatorEmail = localStorage.getItem("EstimatorEmail");

        var signs = JSON.parse(localStorage.getItem("signs") || "[]");
        var signFirst = signs[0];
        var signSecond = signs[1];
        //signature2:  signSecond.sign
        var params = {
            "customerID": Customer.customerID,
            "moveID": Customer.moveID,
            "MoveDailySheetID": Customer.moveDailySheetID,
            "EstimatorID": Customer.estimatorID,
            "CustomerSignature": signFirst.sign,
            "EstimatorSignature": "",
            "EstimatorEmail": estimatorEmail,
            "CustomerEmail": Customer.customerEmail,
            "Body": "",
            "BranchID": Customer.branchID,
            "ZipCodeSameLocation": "no"

        }
        makeRequest("SendQuoteEmail", params)
            .then(function (success) {
                console.log("SendQuoteEmail RESPONSE", success);
            })
            .catch(function (err) {
                console.error('there was an error!', err.statusText);
            });

    }

    // showHideFooter(){
    //     var key=this.props.form.currentFormPage.key;
    //     var isAffirm=(localStorage.getItem("isAffirm") || "0");
    //     if(key.toLowerCase()=="paperwork"){
    //         if(isAffirm=="1"){
    //             return false;
    //         }else{
    //             return true;
    //         }
    //     }
    //     else{
    //         //this.setState({ footer: !!nextFormPage.footer })
    //     }
    //     return false;
    // }

    showFooter() {
        //this.setState({footer:true});
    }

    hideFooter() {
        //this.setState({footer:false});
    }
    // endNav();

    renderFooter() {
        var signs = this.props.formGroup.value.sign;
        //debugger;
        if (this.state.footer) {

        }
    }
    render() {
        var isAffirm = (localStorage.getItem("isAffirm") || "0");
        return (
            <div className="form-section" style={{ width: this.props.width }}>
                <div className="header-section">
                    <Header backIcon={true} onLogoPress={() => this.onLogoPress()} onBackPress={() => this.onBackPress()} progress={this.state.progress} leftIcon={'arrow-left'} rightIcon={'phone'} rightText={"Call Us"} />

                </div>
                <div className="section-padding">
                    <Slider
                        ref={(ref: any) => this.sliderRef = ref}
                        {...this.state.swiperSetting}
                        initialSlide={this.state.initialSlide}
                    >
                        {this.props.form.formPages.map((formPage: IFormPage, index: number) => {
                            return (
                                <div key={index}>
                                    {formPage.title &&
                                        <FormTitle title={formPage.title} subTitle={formPage.subTitle}></FormTitle>
                                    }

                                    <FormSection
                                        formPage={formPage}
                                        onClick={() => this.onFormPageButtonClick()}
                                    >
                                    </FormSection>
                                </div>
                            );
                        })}
                    </Slider>
                </div>
                {this.state.footer &&
                    <div className="main-footer">
                        {/* <Select
                            label={"I'M NOT SURE"}
                            onBubbleSelect={() => this.onFooterTap()} />
                        <div className="footer-icon" onClick={() => this.onFooterTap()}>
                            <SimpleLineIcon name="arrow-right" />
                        </div> */}
                        <div className="bookmove-btn">
                            <Button
                                text={this.state.text}
                                onClick={() => this.goToBottom()}
                            />
                        </div>
                    </div>


                }

                {/* { this.renderFooter()} */}
            </div>
        )
    }
};

export default Form;
